import { NgClass } from '@angular/common';
import { Component, input, OnDestroy, output } from '@angular/core';
import { EMPTY, switchMap, timer } from 'rxjs';
import { SvgIconComponent } from '../svg-icon/svg-icon.component';
import { toObservable } from '@angular/core/rxjs-interop';

@Component({
  selector: 'app-notify',
  imports: [NgClass, SvgIconComponent],
  templateUrl: './notify.component.html',
  styleUrls: ['notify.component.css']
})
export class NotifyComponent implements OnDestroy {

  icon = input<string>()     // имя иконки
  color = input<'default' | 'success' | 'error'>('default')
  showClose = input(true)    // показывать кнопку Закрыть
  expire = input(5000)       // время жизни уведомления

  closeElement  = output()
  expireElement = output()

  private sb = toObservable(this.expire).pipe(
    switchMap(expire => expire ? timer(expire) : EMPTY)
  ).subscribe(() => this.expireElement.emit())

  ngOnDestroy() {
    this.sb.unsubscribe()
  }

}
